<div class="medium-layout">
  <div class="layout">
    <div class="header-main">
      <div class="header-inner align-items-center">
        <div class="company-logo pointer">
          <img src="../../../assets/images/mobilemenu.png" alt="" style="margin-right: 20px;" class="block lg:hidden"
            (click)="mobileMenu=true;">
          <img src="../../../assets/images/FutsalOz 1.png" alt="" [routerLink]="['/']">
          <h3 class="white-space-nowrap" [routerLink]="['/']">FUTSAL OZ</h3>
        </div>
        <div class="navigation hidden lg:block">
          <ul class="link-group">
            <li class="navigation-links" routerLinkActive="active" *ngFor="let item of headerMenus;index as i; ">
              <img class="icons" src="{{item.img}}" alt="">
              <a [routerLink]="[item.routeLink]" (click)="clickOnMenu(i)">{{item.lable}}</a>
            </li>
          </ul>
        </div>
        <div *ngIf="isLogin" class="hidden sm:flex flex-row align-items-center">
          <img class="user-icon" *ngIf="loginUser" src="{{ loginUser?.friendly_photo || loginUser?.profile_picture }}"
            onError="this.src='../../../assets/images/layer-1.png'">
          <p class="user-name" *ngIf="loginUser">{{loginUser?.first_name}} {{loginUser?.last_name}}</p>
          <div #mydiv style="position: relative;">
            <img (click)="op.toggle($event)" class="menu-drop pointer" src="../../../assets/images/icons/time.png">
          </div>
          <!-- menu -->
          <p-overlayPanel #op styleClass="custom-header-menu" [appendTo]="mydiv">
            <ng-template pTemplate>
              <div>
                <div *ngFor="let menu of menuList" class="main-menu-text flex flex-row pointer"
                  [class.active]="menu.link==router.url" (click)="navigation(menu,op)">
                  <div class="menu-log" [ngStyle]="{ '-webkit-mask-image': 'url(' + menu.icon + ')'}"></div>
                  <p class="menu-text">{{menu.label}}</p>
                </div>
              </div>
            </ng-template>
          </p-overlayPanel>
          <!-- menu over-->
        </div>
        <a *ngIf="!isLogin" href="javascript:;" [routerLink]="['/login']" class="login-signup-text hidden sm:flex">Login
          / Signup</a>
        <!-- <div class="nav-bars">
          <img class="header_images" src="../../../assets/images/megnifire.png" alt="">
          <img src="../../../assets/images/Line 1.png" alt="">
          <img src="../../../assets/images/Group 4.png" alt="">
        </div> -->
      </div>
    </div>
  </div>
</div>
<div class="mobile-menu-main" [class.active]="mobileMenu">
  <div class="mobile-menu  flex flex-column justify-content-between">
    <div>
      <div class="flex flex-row pointer align-items-center mobile-menu-logo" [routerLink]="['/']"
        (click)="hideMobileMenu()">
        <img src="../../../assets/images/FutsalOz 1.png" alt="" style="width: 32px;">
        <h3 class="white-space-nowrap title">FUTSAL OZ</h3>
      </div>
      <div class="mobile-menu-list flex flex-column">
        <div routerLinkActive="active" *ngFor="let item of headerMenus;index as i; "
          class="mobile-menu-item flex flex-row align-items-center pointer" [routerLink]="[item.routeLink]"
          (click)="clickOnMenu(i)">
          <img class="icons" src="{{item.img}}" alt="">
          <a>{{item.lable}}</a>
        </div>
      </div>
    </div>
    <div style="padding-left: 50px;" class="sm:hidden flex">
      <a *ngIf="!isLogin" href="javascript:;" [routerLink]="['/login']" class="login-signup-text">Login / Signup</a>

      <div *ngIf="isLogin" class="flex flex-row align-items-center">
        <img class="user-icon" *ngIf="loginUser" src="{{ loginUser?.friendly_photo || loginUser?.profile_picture }}"
          onError="this.src='../../../assets/images/layer-1.png'">
        <p class="user-name" *ngIf="loginUser">{{loginUser?.first_name}} {{loginUser?.last_name}}</p>
        <div #mydiv style="position: relative;">
          <img (click)="op2.toggle($event)" class="menu-drop pointer" src="../../../assets/images/icons/time.png">
        </div>
        <!-- menu -->
        <p-overlayPanel #op2 styleClass="custom-header-menu custom-header-menu2" [appendTo]="mydiv">
          <ng-template pTemplate>
            <div>
              <div *ngFor="let menu of menuList" class="main-menu-text flex flex-row pointer"
                [class.active]="menu.link==router.url" (click)="navigation(menu,op2)">
                <div class="menu-log" [ngStyle]="{ '-webkit-mask-image': 'url(' + menu.icon + ')'}"></div>
                <p class="menu-text">{{menu.label}}</p>
              </div>
            </div>
          </ng-template>
        </p-overlayPanel>
        <!-- menu over-->

      </div>
    </div>
  </div>
  <div class="flex-auto" (click)="hideMobileMenu()"></div>
</div>